import React, { useState } from 'react';
import * as apiUtil from "../../../util/apiUtil";

const GoogleIcon = ({ style }) => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={style}>
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
        <path fill="none" d="M0 0h48v48H0z"></path>
    </svg>
);

const GoogleConnectView = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const handleConnect = () => {
        const redirectUri = window.location.origin + '/auth/google/callback';
        // console.log("Expected Redirect URI:", redirectUri);

        apiUtil.asyncRequest({
            url: `/api/auth/google/url?redirectUri=${encodeURIComponent(redirectUri)}`,
            method: apiUtil.requestMethod.GET,
            success: (result) => {
                window.location.href = result.url;
            }
        });
    };

    return (
        <div className="container-xxl">
            <h2 className='fs-4 mb-4'>설문 관리</h2>
            <div className="card text-center p-5">
                <div className="card-body">
                    <div className="mb-4">
                        <GoogleIcon style={{ width: '64px', height: '64px', marginBottom: '20px' }} />
                        <h3 className="mb-3">Google 계정 연동이 필요합니다</h3>
                        <p className="text-muted mb-4">
                            설문 폼을 생성하기 위해서는 Google 계정 연동이 필요합니다.<br />
                            연동 시 사용자의 Google Drive에 설문 폼이 안전하게 저장됩니다.<br />
                            설문 응답은 연동한 구글 계정에서만 확인 가능합니다.<br />
                            회사에서 사용하는 경우 개인 계정이 아닌 공용(관리) 계정으로 연동해 주세요.
                        </p>
                    </div>
                    <button
                        onClick={handleConnect}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => { setIsHovered(false); setIsActive(false); }}
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        style={{
                            backgroundColor: isActive ? '#eeeeee' : (isHovered ? '#f8f9fa' : '#ffffff'),
                            color: '#3c4043',
                            border: '1px solid #dadce0',
                            borderRadius: '4px',
                            padding: '0 16px 0 0',
                            fontWeight: '500',
                            fontSize: '14px',
                            fontFamily: '"Google Sans", Roboto, Arial, sans-serif',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            boxShadow: isHovered 
                                ? '0 1px 3px 1px rgba(60,64,67,0.15), 0 1px 2px 0 rgba(60,64,67,0.30)' 
                                : 'none',
                            transition: 'background-color 0.2s, box-shadow 0.2s',
                        }}
                    >
                        <div style={{ padding: '8px', marginRight: '8px', borderRadius: '4px 0 0 4px', display: 'flex', alignItems: 'center' }}>
                            <GoogleIcon style={{ width: '18px', height: '18px' }} />
                        </div>
                        <span style={{ padding: '8px 0' }}>Google 계정 연동하기</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GoogleConnectView;
